import React, { useState } from "react";
import { Formik } from "formik";
import { UsersValidation } from "./UsersValidation";
import { Drawer, FormControlLabel, Grid, Switch, Typography, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/CloseOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import RefreshIcon from "@mui/icons-material/Refresh";
import IconButtonIcons from "../../Common/IconButtonIcons";
import Input from "../../Common/Input";
import Button from "../../Common/Button";
import BasicSelect from "../../Common/Select";
import { useDispatch } from "react-redux";

import { setSnackBar } from "../../../store/common/commonSlice";
import { useAddNewUserMutation, useUpdateUserMutation, useGetUsersDropdownQuery } from "../../../store/users/usersApis";
import { useGetRegionsDropdownQuery } from "../../../store/masters/mastersApis";

export const UsersAddDrawer = ({ initialValues, show, close, formType }) => {
    const dispatch = useDispatch();
    const [addNewUser, { isLoading: addUserLoading }] = useAddNewUserMutation();
    const [updateUser, { isLoading: updateUserLoading }] = useUpdateUserMutation();
    const [showPassword, setShowPassword] = useState(false);

    // Get distributors for parent_id dropdown when staff is selected
    const { data: distributorsList } = useGetUsersDropdownQuery({ role: "distributor" });

    // Get regions for region_id dropdown
    const { data: regionsList } = useGetRegionsDropdownQuery();

    const disabled = formType === "View" ? true : false;

    const onFormSubmit = async (values, resetForm) => {
        try {
            let payload = {
                ...values,
                is_active: values.is_active !== false, // Ensure boolean value
            };

            // Remove password from payload if it's empty (for updates)
            if (formType === "Edit" && !payload.password) {
                delete payload.password;
            }

            if (formType === "Edit") {
                await updateUser(payload).unwrap();
                dispatch(
                    setSnackBar({
                        open: true,
                        message: `User updated successfully`,
                        severity: "success",
                    }),
                );
            } else {
                await addNewUser(payload).unwrap();
                dispatch(
                    setSnackBar({
                        open: true,
                        message: `User created successfully`,
                        severity: "success",
                    }),
                );
            }
            close();
            resetForm();
        } catch (error) {
            dispatch(
                setSnackBar({
                    open: true,
                    message: error?.data?.message || error.message,
                    severity: "error",
                }),
            );
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const generatePassword = () => {
        const length = 12;
        const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*";
        let password = "";

        // Ensure at least one character from each required type
        const lowercase = "abcdefghijklmnopqrstuvwxyz";
        const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        const numbers = "0123456789";
        const symbols = "!@#$%^&*";

        password += lowercase.charAt(Math.floor(Math.random() * lowercase.length));
        password += uppercase.charAt(Math.floor(Math.random() * uppercase.length));
        password += numbers.charAt(Math.floor(Math.random() * numbers.length));
        password += symbols.charAt(Math.floor(Math.random() * symbols.length));

        // Fill the rest with random characters
        for (let i = 4; i < length; i++) {
            password += charset.charAt(Math.floor(Math.random() * charset.length));
        }

        // Shuffle the password
        return password
            .split("")
            .sort(() => Math.random() - 0.5)
            .join("");
    };

    const getDefaultRoles = () => {
        return [
            { value: "admin", label: "Admin" },
            { value: "distributor", label: "Distributor" },
            { value: "staff", label: "Staff" },
        ];
    };

    console.log(initialValues, "initialValuesinitialValues");

    return (
        <Formik
            enableReinitialize
            initialValues={{
                name: "",
                email: "",
                mobile: "",
                role: "",
                password: "",
                is_active: true,
                is_b2b: false,
                parent_id: "",
                region_id: "",
                dob: "",
                full_address: "",
                aadhar_number: "",
                ...initialValues,
            }}
            onSubmit={(values, { resetForm }) => {
                onFormSubmit(values, resetForm);
            }}
            validationSchema={UsersValidation}
        >
            {({ handleChange, handleBlur, handleSubmit, values, errors, setFieldValue }) => (
                <Drawer
                    anchor={"right"}
                    open={show}
                    PaperProps={{
                        sx: { width: { xs: "100%", md: "30%", sm: "30%", lg: "30%" } },
                    }}
                    onClose={() => close()}
                >
                    {console.log(errors, "errorserrors")}
                    <Grid container sx={{ display: "flex" }} direction={"column"} width={"100%"} height={"100%"}>
                        <Grid
                            container
                            flex={0}
                            px={2}
                            py={1}
                            borderBottom={1}
                            borderColor={"rgba(5, 5, 5, 0.06)"}
                            justifyContent={"space-between"}
                        >
                            <Grid item alignSelf={"center"}>
                                <Typography variant="h6">
                                    {formType === "Add"
                                        ? `Create new user`
                                        : formType === "Edit"
                                        ? `Update user`
                                        : `View user`}
                                </Typography>
                            </Grid>
                            <Grid item alignSelf={"center"}>
                                <IconButtonIcons
                                    color="default"
                                    title="Close"
                                    IconComponent={CloseIcon}
                                    onClick={() => close()}
                                />
                            </Grid>
                        </Grid>
                        <Grid flex={1} px={2} py={2} overflow={"auto"}>
                            <Grid container spacing={2}>
                                {formType !== "Add" && (
                                    <Grid item xs={12} md={12}>
                                        <Input
                                            label="ID number"
                                            value={values?.id || ""}
                                            fullWidth
                                            disabled={true}
                                            sx={{ backgroundColor: "#FAFAFA" }}
                                        />
                                    </Grid>
                                )}
                                <Grid item xs={12} md={12}>
                                    <Input
                                        id="name"
                                        name="name"
                                        label="Full Name"
                                        placeholder="Enter full name"
                                        onChange={handleChange("name")}
                                        onBlur={handleBlur("name")}
                                        value={values?.name || ""}
                                        error={Boolean(errors.name)}
                                        helperText={errors.name}
                                        fullWidth
                                        disabled={disabled}
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Input
                                        id="email"
                                        name="email"
                                        label="Email Address"
                                        placeholder="Enter email address"
                                        onChange={handleChange("email")}
                                        onBlur={handleBlur("email")}
                                        value={values?.email || ""}
                                        error={Boolean(errors.email)}
                                        helperText={errors.email}
                                        fullWidth
                                        disabled={disabled}
                                        type="email"
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Input
                                        id="mobile"
                                        name="mobile"
                                        label="Mobile Number"
                                        placeholder="Enter mobile number"
                                        onChange={handleChange("mobile")}
                                        onBlur={handleBlur("mobile")}
                                        value={values?.mobile || ""}
                                        error={Boolean(errors.mobile)}
                                        helperText={errors.mobile}
                                        fullWidth
                                        disabled={disabled}
                                        inputProps={{
                                            maxLength: 15,
                                        }}
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Input
                                        id="dob"
                                        name="dob"
                                        label="Date of Birth"
                                        placeholder="YYYY-MM-DD"
                                        onChange={handleChange("dob")}
                                        onBlur={handleBlur("dob")}
                                        value={values?.dob || ""}
                                        error={Boolean(errors.dob)}
                                        helperText={errors.dob || "Format: YYYY-MM-DD"}
                                        fullWidth
                                        disabled={disabled}
                                        type="date"
                                        size="small"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Input
                                        id="full_address"
                                        name="full_address"
                                        label="Full Address"
                                        placeholder="Enter complete address"
                                        onChange={handleChange("full_address")}
                                        onBlur={handleBlur("full_address")}
                                        value={values?.full_address || ""}
                                        error={Boolean(errors.full_address)}
                                        helperText={errors.full_address}
                                        fullWidth
                                        disabled={disabled}
                                        multiline
                                        rows={3}
                                        inputProps={{
                                            maxLength: 1000,
                                        }}
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Input
                                        id="aadhar_number"
                                        name="aadhar_number"
                                        label="Aadhar Number"
                                        placeholder="Enter 12-digit Aadhar number"
                                        onChange={handleChange("aadhar_number")}
                                        onBlur={handleBlur("aadhar_number")}
                                        value={values?.aadhar_number || ""}
                                        error={Boolean(errors.aadhar_number)}
                                        helperText={errors.aadhar_number || "Enter 12-digit Aadhar number (optional)"}
                                        fullWidth
                                        disabled={disabled}
                                        inputProps={{
                                            maxLength: 12,
                                            pattern: "[0-9]*",
                                        }}
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <BasicSelect
                                        name="role"
                                        label="Role"
                                        placeholder="Select role"
                                        options={getDefaultRoles()}
                                        onChange={(e) => {
                                            handleChange("role")(e);
                                            // Clear parent_id when role changes
                                            setFieldValue("parent_id", "");
                                        }}
                                        value={values?.role || ""}
                                        error={Boolean(errors.role)}
                                        helperText={errors.role}
                                        disabled={disabled}
                                        size="small"
                                    />
                                </Grid>

                                {/* Region field for all roles */}
                                <Grid item xs={12} md={12}>
                                    <BasicSelect
                                        name="region_id"
                                        label="Region"
                                        placeholder="Select region"
                                        options={regionsList || []}
                                        onChange={handleChange("region_id")}
                                        value={values?.region_id || ""}
                                        error={Boolean(errors.region_id)}
                                        helperText={errors.region_id || "Select the region for this user"}
                                        disabled={disabled}
                                        size="small"
                                        isClearable={true}
                                    />
                                </Grid>

                                {/* Show distributor dropdown for staff role */}
                                {values?.role === "staff" && (
                                    <Grid item xs={12} md={12}>
                                        <BasicSelect
                                            name="parent_id"
                                            label="Reports To (Distributor) - Optional"
                                            placeholder="Select distributor"
                                            options={
                                                distributorsList?.results?.map((dist) => ({
                                                    value: dist.id,
                                                    label: dist.name,
                                                })) || []
                                            }
                                            onChange={handleChange("parent_id")}
                                            value={values?.parent_id || ""}
                                            error={Boolean(errors.parent_id)}
                                            helperText={
                                                errors.parent_id ||
                                                "Select the distributor this staff reports to (optional)"
                                            }
                                            disabled={disabled}
                                            size="small"
                                            isClearable={true}
                                        />
                                    </Grid>
                                )}

                                {/* Show B2B toggle for staff role only */}
                                {values?.role === "staff" && (
                                    <Grid item xs={12} md={12}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={values?.is_b2b || false}
                                                    onChange={(e) => setFieldValue("is_b2b", e.target.checked)}
                                                    disabled={disabled}
                                                    color="primary"
                                                />
                                            }
                                            label={
                                                <Typography
                                                    variant="body2"
                                                    sx={{ color: values?.is_b2b ? "#4CAF50" : "#666" }}
                                                >
                                                    {values?.is_b2b ? "B2B User" : "Regular User"}
                                                </Typography>
                                            }
                                        />
                                    </Grid>
                                )}

                                {formType === "Add" && (
                                    <Grid item xs={12} md={12}>
                                        <Box sx={{ position: "relative" }}>
                                            <Input
                                                id="password"
                                                name="password"
                                                label="Password"
                                                placeholder="Enter password"
                                                onChange={handleChange("password")}
                                                onBlur={handleBlur("password")}
                                                value={values?.password || ""}
                                                error={Boolean(errors.password)}
                                                helperText={
                                                    errors.password ||
                                                    "Minimum 8 characters with uppercase, lowercase, number and special character"
                                                }
                                                fullWidth
                                                disabled={disabled}
                                                type={showPassword ? "text" : "password"}
                                                size="small"
                                                inputProps={{
                                                    maxLength: 50,
                                                }}
                                            />
                                            <IconButton
                                                onClick={togglePasswordVisibility}
                                                sx={{
                                                    position: "absolute",
                                                    right: 8,
                                                    top: "50%",
                                                    transform: "translateY(-50%)",
                                                    color: "#666",
                                                }}
                                            >
                                                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                            </IconButton>
                                        </Box>
                                        <Box sx={{ mt: 1, display: "flex", justifyContent: "flex-end" }}>
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                startIcon={<RefreshIcon />}
                                                onClick={() => {
                                                    const newPassword = generatePassword();
                                                    setFieldValue("password", newPassword);
                                                }}
                                                disabled={disabled}
                                                sx={{
                                                    fontSize: "0.75rem",
                                                    textTransform: "none",
                                                    minWidth: "auto",
                                                    px: 2,
                                                }}
                                            >
                                                Generate Password
                                            </Button>
                                        </Box>
                                    </Grid>
                                )}
                                {formType === "Edit" && (
                                    <Grid item xs={12} md={12}>
                                        <Box sx={{ position: "relative" }}>
                                            <Input
                                                id="password"
                                                name="password"
                                                label="New Password (Optional)"
                                                placeholder="Enter new password to update"
                                                onChange={handleChange("password")}
                                                onBlur={handleBlur("password")}
                                                value={values?.password || ""}
                                                error={Boolean(errors.password)}
                                                helperText={errors.password || "Leave empty to keep current password"}
                                                fullWidth
                                                disabled={disabled}
                                                type={showPassword ? "text" : "password"}
                                                size="small"
                                                inputProps={{
                                                    maxLength: 50,
                                                }}
                                            />
                                            <IconButton
                                                onClick={togglePasswordVisibility}
                                                sx={{
                                                    position: "absolute",
                                                    right: 8,
                                                    top: "50%",
                                                    transform: "translateY(-50%)",
                                                    color: "#666",
                                                }}
                                            >
                                                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                            </IconButton>
                                        </Box>
                                        <Box sx={{ mt: 1, display: "flex", justifyContent: "flex-end" }}>
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                startIcon={<RefreshIcon />}
                                                onClick={() => {
                                                    const newPassword = generatePassword();
                                                    setFieldValue("password", newPassword);
                                                }}
                                                disabled={disabled}
                                                sx={{
                                                    fontSize: "0.75rem",
                                                    textTransform: "none",
                                                    minWidth: "auto",
                                                    px: 2,
                                                }}
                                            >
                                                Generate Password
                                            </Button>
                                        </Box>
                                    </Grid>
                                )}
                                {formType === "Edit" && (
                                    <Grid item xs={12} md={12}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={values?.is_active !== false}
                                                    onChange={(e) => setFieldValue("is_active", e.target.checked)}
                                                    disabled={disabled}
                                                    color="primary"
                                                />
                                            }
                                            label={
                                                <Typography
                                                    variant="body2"
                                                    sx={{ color: values?.is_active !== false ? "#4CAF50" : "#666" }}
                                                >
                                                    {values?.is_active !== false ? "Active" : "Inactive"}
                                                </Typography>
                                            }
                                        />
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                        {formType !== "View" ? (
                            <Grid
                                flexShrink={0}
                                borderTop={1}
                                borderColor={"rgba(152, 188, 252, 0.16)"}
                                sx={{ padding: "8px 16px" }}
                            >
                                <Grid sx={{ display: "flex", justifyContent: "flex-end" }}>
                                    <Grid sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        <Button
                                            size="medium"
                                            type="submit"
                                            loading={addUserLoading || updateUserLoading}
                                            onClick={() => handleSubmit()}
                                        >
                                            {formType === "Add" ? `Create user` : `Update user`}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        ) : null}
                    </Grid>
                </Drawer>
            )}
        </Formik>
    );
};
